import { Icon } from "semantic-ui-react";

const ProductResultItem = ({ item, isSelected, isHovered, onToggle, onMouseEnter, onMouseLeave }) => (
  <div
    role="button"
    tabIndex={0}
    onClick={() => onToggle(item)}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onToggle(item);
      }
    }}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    style={{
      padding: "5px 12px",
      cursor: "pointer",
      background: isSelected ? "#e8f4e8" : isHovered ? "#f0f8ff" : "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: "1px solid #e0e1e2",
    }}
  >
    <div style={{ minWidth: 0, flex: 1, marginRight: "8px" }}>
      {item.item_name && (
        <div
          style={{
            fontSize: "13px",
            fontWeight: 600,
            color: "#2D2D2D",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {item.item_name}
        </div>
      )}
      <div style={{ fontSize: "11px", fontFamily: "monospace", color: "#888" }}>{item.sku_id}</div>
    </div>
    {isSelected ? (
      <Icon
        name="check"
        style={{ color: "#21ba45", margin: 0 }}
      />
    ) : isHovered ? (
      <span style={{ fontSize: "11px", color: "#888" }}>+ Add</span>
    ) : null}
  </div>
);

export default ProductResultItem;
